export const BASE_URL = process.env.REACT_APP_AIMD_API_URL;

export const IDENTITY_URL = BASE_URL + '/user/me';
export const UPDATE_USER_DATA_URL = BASE_URL + '/user/update';
export const UPDATE_USER_2FA_URL = BASE_URL + '/user/2fa/enable';
export const UPDATE_PHONE_VERIFICATION_DATE_OF_PROMPTING = BASE_URL + '/user/prompt-user-to-verify-phone';
export const REGISTER_ASSESSMENT_RESULTS_URL = BASE_URL + '/user/register-assessment-result-link';
export const ASSESSMENT_RESULTS_URL = BASE_URL + '/user/assessment-result-link';

export const LOGIN_URL = BASE_URL + '/token';
export const REGISTER_URL = BASE_URL + '/register';
export const SEND_VERIFY_URL = BASE_URL + '/email-verification/send';
export const VERIFY_URL = BASE_URL + '/email-verification/verify';
export const SEND_TEXT_URL = BASE_URL + '/text-verification/send';
export const TEXT_VERIFY_URL = BASE_URL + '/text-verification/verify';
export const FORGOT_PASSWORD_URL = BASE_URL + '/password-reset/request';
export const PASSWORD_RESET_URL = BASE_URL + '/password-reset';
export const AUTH_CODE_SEND_URL = BASE_URL + '/auth/code';
export const AUTHENTICATE_URL = BASE_URL + '/auth/pre-login';
export const ANON_LOGIN_URL = BASE_URL + '/token/anon';
export const EMAIL_AUTH_CODE_VERIFICATION = BASE_URL + '/2fa-email-verification/verify';

export const ACTIVITY_CLICK_URL = BASE_URL + '/activity/click';

export const REFRESH_TOKEN_URL = BASE_URL + '/refresh-token';
export const ASSESSMENT_URL = BASE_URL + '/assessment';
export const ASSESSMENT_POST_URL = BASE_URL + '/assessment/new';
export const ASSESSMENTID_GET_URL = BASE_URL + '/assessment/';

export const DEMOGRAPHICS_URL = BASE_URL + '/demographics';
export const DEMOGRAPHICS_PATCH_URL = BASE_URL + '/demographics/update-demographics';
export const DEMOGRAPHICS_ETHNICITIES_URL = DEMOGRAPHICS_URL + '/ethnicities';
export const DEMOGRAPHICS_GENDERS_URL = DEMOGRAPHICS_URL + '/genders';

export const DERMA_BASE_URL = BASE_URL + '/skin1';
export const DERMA_NEXT_QUESTIONS_URL = DERMA_BASE_URL + '/next_questions';
export const DERMA_IMAGE_URLS_URL = DERMA_BASE_URL + '/image/new';
export const DERMA_IMAGE_VALIDITY_URL = DERMA_BASE_URL + '/image/validity';
export const DERMA_DIAGNOSE_URL = DERMA_BASE_URL + '/diagnose';

export const SEXUAL_BASE_URL = BASE_URL + '/infections1';
export const SEXUAL_IMAGE_URL = SEXUAL_BASE_URL + '/image/new';
export const SEXUAL_DIAGNOSE_URL = SEXUAL_BASE_URL + '/diagnose';

export const COUGH_BASE_URL = BASE_URL + '/cough';
export const COUGH_RECORDING_URL = COUGH_BASE_URL + '/recording';

export const NURALOGIX_TOKEN_URL = BASE_URL + '/vitals1/token';
export const NURALOGIX_USERID_URL = BASE_URL + '/user/vitals1';
export const NURALOGIX_RESULTS_VITALS_URL = BASE_URL + '/results/vitals';
export const NURALOGIX_URL_ANON = BASE_URL + '/vitals1/url/anon';

export const RADHAS_ASSESSMENT_DIAGNOSE_URL = 'diagnose';
export const RADHAS_RESULTS_CONDITIONS_URL = BASE_URL + '/results/conditions';

export const SYMPTOM_CHECKER_HISTORY_URL = BASE_URL + '/results/history/conditions';
export const VITALS_HISTORY_URL = BASE_URL + '/results/history/vitals';
export const STREAKS_URL = BASE_URL + '/results/streak';

export const USER_FEEDBACK_URL = BASE_URL + '/feedback';
export const USER_FEEDBACK_VERIFY = USER_FEEDBACK_URL + '/complete';
export const USER_PLAN_URL = BASE_URL + '/user/plan';
export const USER_COUNT_URL = BASE_URL + '/user/user-count';
export const USER_TRIAL_URL = BASE_URL + '/user/start_trial';
export const USER_CONSENT_URL = BASE_URL + '/user/user-consent';

export const PROMO_CODE_EMAIL_URL = BASE_URL + '/promo/email';
export const PROMO_CODE_VERIFY_USER = BASE_URL + '/promo/has_code';
export const PROMO_REDEEM_PROMO_CODE_URL = BASE_URL + '/promo/demo';

export const PAYMENT_CHECKOUT_URL = BASE_URL + '/payments/checkout';
export const PAYMENT_PORTAL_URL = BASE_URL + '/payments/portal';

export const RECOMMENDED_PRODUCTS_URL = BASE_URL + '/recommend';

export const USER_CREDITS_URL = BASE_URL + '/user/user-credit';

export const CLIENT_ASSESS_URL = BASE_URL + '/client/assess';
export const CLIENT_ASSESS_GET_URL = BASE_URL + '/client/assessment';
export const CLIENT_PRODUCT_RECOMMEND_URL = BASE_URL + '/client/product-recommend';
export const CLIENT_DEMOGRAPHICS_URL = BASE_URL + '/client/demographics';
export const CLIENT_DOKTOR_STRIP_URL = BASE_URL + '/payments/client/docktor-connect/checkout';
export const CLIENT_LAB_TEST_RECOMMEND_URL = BASE_URL + '/client/lab-test-recommendations';

export const CLIENT_DOKTOR_SHOW_RESULTS = BASE_URL + '/client/docktor-connect/show-results';

export const CLIENT_SOCIAL_SHARING_POST_DOKTOR = BASE_URL + '/client/result-image';
export const CLIENT_SOCIAL_SHARING_GET_DOKTOR = BASE_URL + '/client/get-result-screenshot/';

export const GET_ALL_GAMEZOP_GAME = BASE_URL + '/games/get-all-game';
